import { render } from "./videoCpn.vue?vue&type=template&id=4c78af14&scoped=true"
const script = {}

import "./videoCpn.vue?vue&type=style&index=0&id=4c78af14&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c78af14"]])

export default __exports__